// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../../themes/theme.module.css\"","lake500":"#00829B","grey300":"#CCCCCC","red500":"#D60000","Icon":"IconWithCounterBadge_Icon__1VZL3"};